import { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
import { initPage } from '../App';
import { useNavigate } from 'react-router-dom';

const Page4 = () => {

  const [showMapa, setShowMapa] = useState(false)

  useEffect(() => {
    initPage();
  }, [])

  const navigate = useNavigate();

  return (
    <div className="page-container">
      <div style={{ backgroundColor: '#0f3460', width: '100%', height: '100%', position: 'relative' }}>
        <img src='/SALA-4.png' alt='Page 4 Background' className='background-image' />

        {/* Porta */}
        <div
          className="clickable-area seta-esquerda"
          style={{
            top: '8%',
            left: '18%',
            width: '16%',
            height: '60%',
          }}
          onClick={() => window.location.href = '/1'}
        />

        {/* mapa */}
        <div
          className="clickable-area"
          style={{
            top: '10%',
            left: '52%',
            width: '16%',
            height: '21%',
            background: 'red',
            opacity: '0%',
            transform: 'rotate(-3deg)',
          }}
          onClick={() => {setShowMapa(true)}}
        />

        {/* mapa */}
        <div
          className="clickable-area"
          style={{
            top: '53%',
            left: '62%',
            width: '36%',
            height: '41%',
            background: 'red',
            opacity: '0',
            transform: 'rotate(25deg)',
          }}
          onClick={() => {navigate('/constelacao')}}
        />

        {
          showMapa &&
          (
            <div className="modal-area">
              <div className="close-button" onClick={() => setShowMapa(false)}>X</div>
              <div className="modal-content">
                <img src='/mapa.png' style={{width: '100%', height: '100%'}} alt="Mapa"/>
              </div>
            </div>
          )
        }

      </div>
    </div>
  );
};

export default Page4;
